import axios from 'utils/http';

// 登录
export function login(data) {
    return axios.post('/admin/user/login', data).then(res => {
        return Promise.resolve(res);
    });
}
// 退出登录
export function logout() {
    return axios.get(`/admin/user/logout`).then(res => {
        return Promise.resolve(res);
    });
}
// 验证码
export function captcha() {
    return axios.get('/misc/captcha/api').then(res => {
        return Promise.resolve(res);
    });
}
// 验证密码
export function psdValidate(data) {
    return axios.post(`/admin/user/psd`, data).then(res => {
        return Promise.resolve(res);
    });
}
// 获取用户信息
export function getUserInfoAjax() {
    return axios({
        url: `/admin/user/profile`,
        method: 'get'
    });
}



// WEBPACK FOOTER //
// ./src/api/login.js